import React, { memo, useState } from 'react';

const EmojiRating = ({
  score, onRate, handleRemoveRating, interActive, small
}) => {
  const [rating, setRating] = useState(null); // Initial rating

  const emojis = [
    { id: 1, imgURL: require('../Images/rating_emoji/1.png') },
    { id: 2, imgURL: require('../Images/rating_emoji/2.svg') },
    { id: 3, imgURL: require('../Images/rating_emoji/3.svg') },
    { id: 4, imgURL: require('../Images/rating_emoji/4.svg') },
    { id: 5, imgURL: require('../Images/rating_emoji/5.svg') }
  ];

  const handleEmojiClick = (value) => {
    if (!interActive) {
      return;
    }
    if (rating === value) {
      setRating(null);
      handleRemoveRating(null);
      return;
    }
    setRating(value);
    onRate(value);
  };

  React.useEffect(() => {
    if (score) {
      setRating(score);
    }
  }, [score]);

  return (
    <div className="emoji-rating-row">
      {emojis.map((emoji, index) => (
        <img
          key={index}
          style={{
            cursor: 'pointer',
            width: small ? '18px' : '30px',
            opacity: rating === emoji.id ? 1 : 0.8,
            filter: rating !== emoji.id ? 'grayscale(100%)' : 'none'
          }}
          onClick={() => {
            handleEmojiClick(emoji.id);
          }}
          src={emoji.imgURL}

        />
      ))}
    </div>
  );
};

export default memo(EmojiRating);
